// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__materialIcons_92065e', '__materialIcons_Fallback_92065e'","fontWeight":400},"className":"__className_92065e"};